import * as styledElements from "./FormValidationErrorStyles";
import { ReactNode } from "react";

const FormValidationError = ({
  validationMessage,
  styleProps,
}: {
  validationMessage: string | ReactNode;
  styleProps?: object;
}) => {
  return (
    <styledElements.Container style={{ ...styleProps }}>
      {validationMessage}
    </styledElements.Container>
  );
};

export default FormValidationError;
